import * as React from "react";
import colors from "tailwindcss/colors";

export default function FundamenteiOutline({
  fill = colors.gray[100],
  stroke = colors.gray[600],
  strokeWidth = 4,
  ...props
}: React.SVGAttributes<any>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 263.526 278.918" width={263.499} height={278.535} {...props}>
      <title>Fundamentei</title>
      <g fill="none" fillRule="nonzero">
        <g fill={fill}>
          <path d="m202.881 1.79-31.614 31.603 31.325 31.314c15.996 15.99 15.996 41.923 0 57.914L80.25 244.92l31.86 31.847 126.946-126.902c30.925-30.914 30.925-81.021 0-111.935L202.881 1.767v.023Z" />
          <path d="m60.619 276.745 31.614-31.603-31.325-31.314c-15.996-15.99-15.996-41.923 0-57.914L183.25 33.615 151.39 1.767 24.445 128.67c-30.925 30.914-30.925 81.021 0 111.935l36.175 36.162v-.022Z" />
        </g>
        <path
          stroke={stroke}
          strokeWidth={strokeWidth}
          d="m151.39 1.767 25.756 25.748L202.841 1.83l36.215 36.101c30.616 30.605 30.922 80.02.919 111.002l-.919.933L112.11 276.767l-25.747-25.736-25.743 25.736-36.175-36.143c-30.925-30.916-30.925-81.027 0-111.944L151.39 1.767Zm25.981 37.728L60.908 155.928c-15.996 15.992-15.996 41.926 0 57.918L86.12 239.05l116.472-116.43c15.836-15.831 15.995-41.405.475-57.431l-.475-.483-25.221-25.211Z"
        />
      </g>
    </svg>
  );
}
